module.exports = __webpack_public_path__ + "img/top2.8cc73668.svg";